import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { PageContainer } from '@/components/templates/PageContainer';
import { ProfilePostCreatorSkeleton, PostCardSkeleton } from '@/components/molecules/skeletons';
import { SKELETON } from '@/lib/constants';

const RightSidebarSkeleton = (
  <div className="sticky top-20 w-40 h-[600px]">
    <Skeleton className="h-full w-full rounded-xl" />
  </div>
);

export const SquarePageSkeleton = memo(() => {
  return (
    <PageContainer rightSidebar={RightSidebarSkeleton}>
      <div className="space-y-6">
        <ProfilePostCreatorSkeleton />
        {Array.from({ length: SKELETON.FEED_INITIAL_CARDS }, (_, i) => (
          <PostCardSkeleton key={i} />
        ))}
      </div>
    </PageContainer>
  );
});

SquarePageSkeleton.displayName = 'SquarePageSkeleton';
